<template>
  <div>
    <div v-if="courseData" class="study">
      <div class="study-box">
        <div class="study-box-head">
          <div class="study-box-head-video">
            <div class="study-box-head-video-hint" v-if="courseData.study_begin_date && !isDuringDate(courseData.study_begin_date, courseData.study_of_date)">
              {{ courseData | duringDateMsg(courseData.study_begin_date, courseData.study_of_date) }}
            </div>
            <div class="study-box-head-video-hint" v-else-if="courseData.join_state === 1">您沒有參加本課程,是否要參加？
              <span class="p-pointer" @click="studyClick(courseData.lessons[0],0,courseData.lessons[0]['wares'][0])">立即參加</span>
            </div>
            <lms-video :key="changKey" :playTime="videoPlayStatus ? listItem.play_time : courseHisroryTotal" :videoApi="videoApi" :resourceError="resourceError" :playingStatus="videoPlayStatus" v-else-if="showType!=='pdf' && courseData.join_state === 0" @playChang="playChang" @playerEnded="playerEnded" @videoReload="videoReload" @videoStateChang="videoStateChang" @resetAccessTime="resetAccessTime" />
            <lms-pdf :key="changKey" :videoApi="videoApi" :resourceError="resourceError" v-else-if="showType === 'pdf' && courseData.join_state === 0" @loaded="onPdfLoaded" />
          </div>
          <div class="study-box-head-list">
            <dl v-for="(items,i) in courseData.lessons" :key="i">
              <dt class="omit" :title="items.name">
                <span class="is-public-tag" style="background-color:#4d4d4d;color:#CECED9">{{ items.is_public == 0 ? '僅內網' : '內外網'}}</span>
                <span>課堂{{i+1}}：{{items.name}}</span>
              </dt>
              <dd class="p-pointer" v-for="(item,index) in items.wares" :key="index" @click="studyClick(items,index,item)" :style="item.id === listCheck && 'color:#4D8EF6'">
                <div class="list-icon">
                  <img v-show="item.extend==='pdf'" style="margin-left:2px;margin-right:12px;" :src="item.id === listCheck ? require('@p/assets/images/icon/pdf1.png') : require('@p/assets/images/icon/pdf.png')">
                  <i :class="item.id !== listCheck || !videoState? 'el-icon-video-play' : 'el-icon-video-pause'" :style="{color: playingStatus(item) ? '#7ac254' : '#ff6161'}" v-show="item.extend!=='pdf'">
                  </i>
                </div>
                <div class="list-p">課時{{index+1}}：{{item.name}}</div>
                <span>{{item.plan_time | setMinutes}}</span>
              </dd>
            </dl>
          </div>
        </div>
        <div class="study-box-progress">
          <span>學習進度</span>
          <div class="study-box-progress-pr">
            <lms-progress :width="courseData.schedule"></lms-progress>
          </div>
          <div class="study-box-progress-evaluate p-pointer" @click="evaluateClick">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconpinglun"></use>
            </svg>
            <span>評價</span>
          </div>
        </div>
      </div>
      <div class="study-con">
        <div class="study-con-box" v-loading="loading">
          <el-tabs stretch v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="簡介" name="1">
              <div class="study-synopsis">
                <h4 class="study-con-rate">
                  <span class="study-synopsis-t">
                    <div class="study-course-tag" :style="{ backgroundColor: courseData.required == 1 ? '#4D8EF6' : '#7AC254' }">{{courseData.required == 1 ? '必修' : '選修'}}</div>
                    {{courseData.name}}
                  </span>
                  <div class="study-con-rate-con">
                    <el-rate v-model="courseData.average" disabled text-color="#ff9900" :show-score="!!rate" score-template="{value}">
                    </el-rate>
                    <span style="display:contents;">
                      <span v-if="courseData.average && courseData.average>0">{{courseData.average.toFixed(1)}}</span>
                      <span>({{courseData.averageCount === 0 ? '暫無評價': courseData.averageCount+'人評價'}})</span>
                    </span>
                  </div>
                </h4>
                <span class="study-time">學員數：{{courseData.staff_count}}</span>
                <span class="study-time">講師：{{lecturers(courseData.lecturers)}}</span>
                <span class="study-time">學習時間：{{ formatTime(courseData.study_begin_date) }} ～ {{ formatTime(courseData.study_of_date) }}</span>
                <span class="study-time">課程描述：{{courseData.description}}</span>
                <i></i>
                <h4>LMS 流程圖目錄</h4>
                <ul v-if="flowData.length>0">
                  <li v-for="(item,index) in flowData" :key="index" @click="toFlow(item.flowchart_name)" class="p-pointer">{{item.flow_full_name}}</li>
                </ul>
                <span style="margin-top:10px;" v-else>新課程未關聯舊流程圖數據</span>
              </div>
            </el-tab-pane>
            <el-tab-pane label="目錄" name="2">
              <dl class="study-catalogue" v-for="(items,i) in courseData.lessons" :key="i">
                <dt>
                  <p>
                    <span class="is-public-tag" style="color:#f2f2f2;background-color:#bfbfbf">{{ items.is_public == 0 ? '僅內網' : '內外網'}}</span>
                    <span>課堂{{i+1}}：{{items.name}}</span>
                  </p>
                  <span class="el-icon-edit p-pointer" @click="goExercisesPage(items)">課堂練習</span>
                </dt>
                <div class="catalogue-list">
                  <div class="catalogue-me">課堂描述： {{items.description}}</div>
                  <i class="catalogue-bor"></i>
                  <dd v-for="(item,index) in items.wares" :key="index" class="p-pointer" @click="studyClick(items,index,item)" :style="item.id === listCheck && 'background:rgba(77,142,246,1);color:#FFFFFF'">
                    <div>課時{{index+1}}：{{item.name}}</div>
                    <div class="study-catalogue-icon" v-show="item.extend!=='pdf'">
                      <i :class="item.id !== listCheck || !videoState? 'el-icon-video-play' : 'el-icon-video-pause'" :style="{color: playingStatus(item) ? '#4ee000' : '#ff6161'}" v-show="item.mime_type==='video/mp4'">
                      </i>
                      <span>{{item.plan_time | setMinutes}}</span>
                    </div>
                  </dd>
                </div>
              </dl>
            </el-tab-pane>
            <el-tab-pane label="考試" name="3">
              <div class="study-exam" v-if="examList.length>0">
                <div v-for="(items,i) in examList" :key="i" v-show="items.status === 1">
                  <h4 :style="i>0 && 'margin-top:30px;'">課堂{{i+1}}：{{items.name}}</h4>
                  <el-row :gutter="68">
                    <el-col class="p-pointer" :span="6" v-for="(item,index) in items.examination" :key="index" style="margin-top:20px;" v-show="item.status === 1 || (item.status !=1 && item.history_count > 0)">
                      <div @click="goExamPage(item)">
                        <lesson-exam-card :imgSrc="require('@p/assets/images/exam.png')" :title="item.name" :describe="`收录考卷：${item.exam_count}张`" :status="item.status" :history_count="item.history_count" />
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
              <div v-else>
                <empty title="暫無考試"></empty>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="study-recommend">
            <h4>課程推薦</h4>
            <ul>
              <li v-for="item in recommend" :key="item.id" @click="$router.replace({path:'/home/lessons/study',query:{id:item.id,title:item.name}})">
                <lesson-card class="p-pointer" :data="item"></lesson-card>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <lms-dialog :drawerVisible='visible' @visible='v=>visible=v' @visibleChang="visibleChang">
        <div class="dialog-body">您是否確定參加該課程的學習？</div>
      </lms-dialog>
      <Lrate :drawerVisible='visible1' @visible='v=>visible1=v' @visibleChang="visibleChang1" width="650px" title="课程评分"></Lrate>
    </div>
    <div v-else style="width: 100%;text-align: center;padding-bottom:20px;margin-top:100px">
      <empty :title="courseErrorMessage"></empty>
    </div>
  </div>
</template>

<script>
import lmsProgress from '@p/components/progress'
import lessonCard from '@p/components/lessonCard';
import lessonExamCard from '@p/components/lessonExamCard';
import lmsVideo from './components/lmsVideo.vue';
import lmsPdf from './components/lmsPdf.vue';
import lmsDialog from '@p/components/lessonDialog/lms-dialog.vue'
import Lrate from '@p/components/lessonDialog/lesson-rate.vue'
import empty from '@p/components/contentEmpty';
import { setTimeStr, formatDateTime, setMinuteSecond, formatIosDateTime } from '@/utils';
export default {
  data () {
    return {
      loading: false,
      videoState: false,           //播放状态
      videoApi: '',                //播放地址
      listItem: '',                //保存播放列表点击
      listItems: '',
      courseData: {},              //课程详情数据      
      activeName: '1',            //tab  
      showType: '',                //当前课件类型
      flowData: [],                //流程图数据
      recommend: [],               //推荐课程数据
      startData: '',               //课件开始时间
      playTime: 0,                 //记录当前播放时间
      examList: [],                //考试列表
      listCheck: '',
      rate: 0,
      visible: false,              //参加课程
      visible1: false,             //评分
      changKey: '',
      accessTime: 0,               // 学习时间
      resourceError: false,
      courseErrorMessage: '找不到課程',
      pdfTime: 0,                  // pdf自动完成
      oldListItem: '',
    }
  },
  computed: {
    // 统计历史记录
    courseHisroryTotal: function () {
      return this.listItem.hisrory ? this.listItem.hisrory.reduce((a, b) => a + b.access_time, 0) : 0;
    },
    // true 是无限制，false是首播限制
    videoPlayStatus: function () {
      if (!this.listItem) {
        return true
      }
      return this.playingStatus(this.listItem);
    }
  },
  created () {
    this.loading = true;
    this.initData(this.$route.query.id);
  },
  mounted () {
    const $this = this;
    window.addEventListener("unload ", () => this.wareStudyHistory(true, true));    //监听页面关闭
    window.onbeforeunload = function () {
      $this.wareStudyHistory(true, true)
    }
  },
  watch: {
    '$route.query': function (v) {             //页面重定向
      this.loading = true;
      this.initData(v.id);
    }
  },
  methods: {
    // 获取课程详情
    async initData (courseId, is = false) {
      await this.$http.course.getCourseDetailsById({ courseId }).then(v => {
        if (v.status === 200) {
          this.accessTime = 0
          this.courseData = v.data.data;
          this.updateCourseTitle(this.courseData);
          if (!v.data.data) this.courseErrorMessage = '找不到課程';
          if (v.data.status_code == 403) this.courseErrorMessage = v.data.message; // 不在学员范围内
          if (this.listItem != '') this.setListItemData(v.data.data.lessons);
          if (!is) this.getCourseOldFormer(courseId);
          if (v.data.data.join_state == 0 && !is) this.setShowOneData();
        }
        this.loading = false;
      }).catch(v => {
        this.loading = false;
        this.$message.error(v.response.data.message);
      })
    },
    // 课程标题与url上的query.title 不同，就更新面包屑
    updateCourseTitle (courseData) {
      if (courseData && this.$route.query.title !== courseData.name) {
        this.$store.commit('setBreadcrumb', {
          path: this.$route.path,
          query: {
            id: courseData.id,
            title: courseData.name,
          },
        })
      }
    },
    //获取课件详情(视频，PDF)
    async getWareDetails (wareId) {
      this.showType = this.listItem.extend;
      this.listCheck = this.listItem.id;
      this.oldListItem = this.listItem
      this.playState = false;
      this.playTime = 0;
      this.accessTime = 0
      this.startData = '';
      this.resourceError = false
      this.videoApi = ''
      this.changKey = + new Date();
      // this.$http.course.cancelWareDetailsTimeout()

      this.$http.course.getWareDetailsById({
        wareId,
        isPublic: this.listItems.is_public
      }).then((res) => {
        this.videoApi = '0'
        if (res.data.status_code === 200) {
          this.videoApi = res.data.data
        }
      }).catch(err => {
        if (err.response.data.status === 403) {
          this.resourceError = true
          this.changKey = + new Date();
        }
      });

    },
    //获取lms 1.0 流程图
    async getCourseOldFormer (courseId) {
      await this.$http.course.getCourseOldFormerFlowchart({ courseId }).then(v => {
        if (v.status === 200 && v.data.status_code === 200) {
          this.flowData = v.data.data;
          this.getHotCourse(courseId);
        }
      }).catch(v => { })
    },
    //获取最新推荐课程
    async getHotCourse (courseId) {
      await this.$http.home.getHotCourse({ params: { page: 1, take: 5 } }).then(v => {
        if (v.status === 200) {
          this.recommend = [];
          v.data.data.data.forEach(item => {
            if (item.required === 0 && this.recommend.length < 5) {
              this.recommend.push(item)
            }
          })
          this.examinations(courseId)
        }
      }).catch(v => { })
    },
    //参加课程
    async bindingCourses (courseId) {
      await this.$http.course.bindingCourses({ courseId }).then(v => {
        if (v.data.status_code === 200) {
          if (this.listItem === '') {
            this.setShowOneData()
          } else {
            this.getWareDetails(this.listItem.id);
          }
          this.initData(this.$route.query.id, true);
        } else if (v.data.status_code == 500) {
          this.$message({
            message: v.data.message,
            type: 'error'
          });
        }
      }).catch(v => { })
    },
    //课件视频学习记录
    async wareStudyHistory (is = false, type) {
      clearInterval(this.pdfTime)
      if (this.showType === 'pdf' && this.pdfHisroryNimiety(this.oldListItem)) return;
      if (JSON.stringify(this.courseData) === '{}' || this.listItem === '' || this.listCheck === '' || this.startData == '' || ((this.playTime === 0 || this.accessTime === 0) && this.showType !== 'pdf')) return;    //无课程数据
      let param = {
        lessonsWareId: this.listCheck,
        startData: this.startData == '' ? parseInt(new Date().getTime() / 1000) : parseInt(this.startData.getTime() / 1000),
        endData: parseInt(new Date().getTime() / 1000),
        accessTime: this.showType === 'pdf' ? parseInt((new Date().getTime() - this.startData.getTime()) / 1000) : this.accessTime,
        playTime: this.playTime ? parseInt(this.playTime) : 0,    //视频时间(秒)
      }
      if (is === true && type === true) {
        //(同步接口)页面刷新和关闭调用
        this.$http.course.syncWareStudyHistory(param);
      } else {
        await this.$http.course.wareStudyHistory(param).then(v => {
          if (v.status === 200) {
            this.playTime = 0;
            this.accessTime = 0;
            if (is) this.initData(this.$route.query.id, true);
          }
        }).catch(v => { })
      }
    },
    // 课件点击
    async studyClick (items, index, item) {
      if (!this.isDuringDate(this.courseData.study_begin_date, this.courseData.study_of_date)) {
        return;
      }
      this.listItem = item;
      this.listItems = items;
      if (this.courseData.join_state === 0) {//1未参加，0参加
        if (this.listItem && this.videoApi) {              //保存上一次观看时间
          this.wareStudyHistory(true)
        }
        await this.getWareDetails(this.listItem.id);
        this.visible = false;
      } else {
        this.visible = true;
      }
    },
    // 视频重新加载
    async videoReload () {
      await this.wareStudyHistory(true)
      await this.getWareDetails(this.listItem.id);
    },
    //确定参加课程
    visibleChang () {
      if (this.courseData.join_state === 1) {//1未参加，0参加
        this.studyClick(this.courseData['lessons'][0], 0, this.courseData['lessons'][0]['wares'][0])
        this.bindingCourses(this.$route.query.id);
        this.visible = false;
      }
    },
    // 播放状态改变
    videoStateChang (state) {
      this.videoState = state;
    },
    //记录播放时间
    playChang (v) {
      if (this.startData === '') this.startData = new Date();  //记录播放开始时间
      if (parseInt(v) > this.playTime) {
        this.accessTime += 1;

        const lessonPlanTime = Math.ceil(this.listItem.plan_time * 60);
        const access_time = this.courseHisroryTotal;
        const videoDuration = parseInt(document.querySelector('video').duration);
        // 无限制视频自动完成
        if (parseInt(v) != videoDuration && (access_time + this.accessTime) === lessonPlanTime) {
          this.wareStudyHistory(true);
        }
      }
      this.playTime = parseInt(v);
    },
    //视频播放结束记录播放时间
    playerEnded () {
      this.videoState = false
      this.wareStudyHistory(true);
    },
    onPdfLoaded () {  // PDF记录开始时间
      this.startData = new Date();
      const listItem = this.listItem
      const access_time = this.courseHisroryTotal;
      clearInterval(this.pdfTime)
      if (access_time <= setMinuteSecond(listItem.plan_time)) {
        const time = setMinuteSecond(listItem.plan_time) - access_time
        if (time != 0) {
          this.pdfTime = setInterval(() => { // 自动完成
            const startData = (+new Date) - time * 1000
            this.startData = new Date(startData)
            this.wareStudyHistory(true);
          }, time * 1000)
        }
      }
    },
    //tab
    handleClick (tab, event) {
    },
    //评分点击
    evaluateClick () {
      if (this.courseData.join_state === 1) {//1未参加，0参加
        this.visible = true;
      } else {
        if (this.courseData.schedule != 100) {
          this.$message({
            message: '學習進度100%才能進行評價！',
            type: 'warning'
          });
          return;
        }
        this.visible1 = true;
      }
    },
    //评分
    visibleChang1 (r, t) {
      if (t === '') {
        this.$message({
          message: '評價內容不能為空！',
          type: 'error'
        });
        return;
      }
      this.$http.personal.evaluate({ course_id: this.$route.query.id, description: t, grade: r }).then(v => {
        if (v.status === 200 && v.data.status_code === 200) {
          this.$message({ message: v.data.message, type: 'success' });
          this.initData(this.$route.query.id, true);
        } else {
          this.$message({ message: v.data.message, type: 'error' });
        }
        this.visible = false;
      }).catch(v => { })
      this.visible1 = !this.visible1;
    },
    //时间格式
    getTime (v) {
      return setTimeStr(v)
    },
    formatTime (v) {
      if (v) {
        return formatDateTime(v, 'yyyy-MM-dd HH:mm');
      }
    },
    //默认播放课时1
    setShowOneData () {
      if (!this.isDuringDate(this.courseData.study_begin_date, this.courseData.study_of_date)) {
        return;
      }
      this.listCheck = this.courseData['lessons'][0]['wares'][0]['id'];
      this.studyClick(this.courseData['lessons'][0], 0, this.courseData['lessons'][0]['wares'][0]);
    },
    //课程考试列表
    async examinations (coures_id) {
      await this.$http.course.examinations({ coures_id }).then(v => {
        if (v.status === 200 && v.data.status_code === 200) {
          this.examList = this.setExaminationSort(v.data.data);
        }
      }).catch(v => { })
    },
    //考试界面课堂排序
    setExaminationSort (examData) {
      const lessonIds = this.courseData.lessons.map(lesson => {
        return lesson.id;
      })
      let resArray = [];
      lessonIds.forEach((lessonId, i) => {
        examData.map(exam => {
          if (exam.id == lessonId) {
            resArray[i] = exam;
            return;
          }
        })
      })
      return resArray;
    },
    //跳转练习
    goExercisesPage (items) {
      if (this.courseData.join_state === 1) {//1未参加，0参加
        this.visible = true;
        return;
      }
      this.$router.push({ path: '/home/lessons/exercises', query: { lessonsId: items.id, title: items.name } })
    },
    //跳转考试
    goExamPage (item) {
      if (this.courseData.join_state === 1) {//1未参加，0参加
        this.visible = true;
        return;
      }
      this.$router.push({ path: '/exam/list', query: { id: item.id, title: item.name, index: 0 } })
    },
    //跳转流程图
    toFlow (name) {
      window.open('http://lms.sjfood.us/course_flow_view.php?flow_name=' + name, '_blank');
    },
    // 讲师
    lecturers (lecturers) {
      if (lecturers) {
        if (Array.isArray(lecturers)) {
          return lecturers.join()
        } else if (typeof (lecturers) === 'object') {
          return Object.values(lecturers).join()
        }
      }
      return ''
    },
    setListItemData (list) {
      let wares = ''
      list.forEach(items => {
        if (wares === '') {
          wares = items.wares.find(item => item.id === this.listItem.id) || ''
        }
      })
      this.listItem = wares
    },
    resetAccessTime (value) {
      this.accessTime = value;
    },
    // 播放限制
    playingStatus (item) {
      if (item.playing_status === 0) { // 0无限制，1首播限制
        return true
      } else {
        if (item.hisrory != null) {
          if (item.hisrory.length > 0) {
            const access_time = item.hisrory.reduce((a, b) => a + b.access_time, 0)
            if (access_time >= setMinuteSecond(item.plan_time)) {
              return true
            }
          }
        }
      }
      return false
    },
    pdfHisroryNimiety (listItem) { // pdf历史记录超过预计时间
      const access_time = listItem.hisrory ? listItem.hisrory.reduce((a, b) => a + b.access_time, 0) : 0;
      if (access_time >= setMinuteSecond(listItem.plan_time)) { //pdf
        return true
      }
      return false
    },
    // 判断当前时间是否在指定时间段
    isDuringDate (beginDateStr, endDateStr) {
      const curDate = new Date();
      const beginDate = new Date(formatIosDateTime(beginDateStr));
      const endDate = new Date(formatIosDateTime(endDateStr));
      if (curDate >= beginDate && curDate <= endDate) {
        return true;
      }
      return false;
    }
  },
  filters: {
    duringDateMsg (beginDateStr, endDateStr) {
      const curDate = new Date();
      const beginDate = new Date(formatIosDateTime(beginDateStr));
      const endDate = new Date(formatIosDateTime(endDateStr));
      if (curDate > endDate) {
        return '課程已過學習時間，無法學習';
      } else {
        return '課程未到學習時間，暫無法學習';
      }
    }
  },
  //保存视频记录，销毁已在方法
  beforeDestroy () {
    this.wareStudyHistory();
    window.onbeforeunload = null;
    window.onunload = null;
  },
  components: {
    lmsProgress, lessonCard, lessonExamCard, lmsVideo, lmsDialog, Lrate, lmsPdf, empty
  }
}
</script>
<style scoped>
.study >>> .el-tabs__nav-wrap {
  padding-right: 600px;
}
.study >>> .el-tabs__active-bar {
  width: 46px !important;
  margin-left: 64px;
}
.study >>> [role="tab"] {
  font-weight: bold;
  font-size: 20px;
  height: 54px;
  line-height: 54px;
}
</style>

<style lang="less" scoped>
@import "./index.less";
</style>
